<form #createlesson="ngForm" name="createlesson" id="createlesson" (ngSubmit)="addlesson()" class="mt-4 mb-0">
  <div class="fieldset fieldset--lg">
    <label class="legend" for="title">Lesson Title <span class="requiredfield">*</span></label>
    <input type="text" class="text-field" required [(ngModel)]="lesson.title" #title name="title" id="title" autofocus>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="publishdate">Publish Date</label>
    <input [owlDateTime]="rawpublisheddatetime" class="text-field" id="publishdate" name="publishdate" #publishdate
      [(ngModel)]="lesson.publishdate">
    <button type="button" [owlDateTimeTrigger]="rawpublisheddatetime"
      class="owlDateTimeTrigger position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      title="Calendar">
      <i class="fa fa-calendar"></i>
    </button>
    <owl-date-time #rawpublisheddatetime></owl-date-time>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Date of availability"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">This is the date from which the lesson will be made available to enrolled participants</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="timeestimate" class="legend">Estimated Completion Duration</label>
    <div>
      <input type="number" name="timeestimate" class="text-field w-50" [(ngModel)]="lesson.timenumber">
      <select class="text-field w-50" #selectTimeUnit>
        <option>Minute(s)</option>
        <option>Hour(s)</option>
      </select>
    </div>
  </div>
  <div class="fieldset fieldset--lg" [hidden]="!activateLessonDeadlineNotification">
    <label class="legend z-1" for="fixedMilestoneDate">Use Publish Date for Lesson Deadline</label>
    <select class="text-field" [(ngModel)]="lesson.usefixeddeadline"
      #fixedMilestoneDate name="fixedMilestoneDate" id="fixedMilestoneDate">
      <option [ngValue]="true">
        Yes
      </option>
      <option [ngValue]="false" selected>
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg" [hidden]="!activateLessonDeadlineNotification">
    <label for="milestoneestimate" class="legend">Lesson Deadline From {{lesson.usefixeddeadline ? 'Publish Date' : 'Start of Lesson'}}</label>
    <div>
      <input type="number" name="milestoneestimate" class="text-field w-50" [(ngModel)]="lesson.milestonetimenumber">
      <select class="text-field w-50" #selectMilestoneTimeUnit>
        <option>Hour(s)</option>
        <option>Day(s)</option>
      </select>
    </div>
  </div>
  <div class="fieldset fieldset--note">
    <label class="legend z-1">Lesson Summary <span class="requiredfield">*</span></label>
    <quill-editor required [(ngModel)]="lesson.description" #description name="description"
      placeholder="Enter Short Description of Lesson"></quill-editor>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button [disabled]="createlesson.invalid && !this.classid" class="btn m-0" type="submit">Save</button>
    <button class="btn btn--warning m-0" type="button" (click)="canceledit()">Cancel</button>
  </div>
</form>